// extracted by mini-css-extract-plugin
export var messageSideLeft = "_st-1";
export var stateContainer = "_st-0";